import { getResourceURL } from '../../services/extServices'

type ButtonProps = {
    icon: string
    title: string
    static?: boolean
    id?: string
    badge?: string // ID of the badge
    bgColor?: string
    onClick?: () => void
}

export const createCTAbtns = (
    tagName: string,
    id: string,
    buttons: ButtonProps[]
) => {
    const buttonsContainer: HTMLElement = document.createElement(tagName)
    buttonsContainer.id = id

    const createCTAButton = btnProps => {
        const ctaBtn = document.createElement('cta')
        const styles = {
            position: 'relative',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '10px',
            padding: '8px',
            width: '40px',
            height: '40px',
            marginRight: '10px',
            backgroundColor: btnProps.bgColor || '#ffffff',
            color: '#090C10',
            fontSize: '16px',
            boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.4)',
            borderRadius: '50%',
            cursor: btnProps.static ? 'default' : 'pointer',
            transition: 'background .3s',
        }
        Object.entries(styles).forEach(([cssKey, cssValue]) => {
            ctaBtn.style[cssKey] = cssValue
        })

        if (!btnProps.static) {
            ctaBtn.addEventListener('mouseenter', () => {
                ctaBtn.style.filter = 'brightness(85%)'
            })
            ctaBtn.addEventListener('mouseleave', () => {
                ctaBtn.style.filter = 'brightness(100%)'
            })
        }

        ctaBtn.title = btnProps.title
        ctaBtn.innerHTML = `${
            btnProps.badge
                ? `<div id="${btnProps.badge}" class="Guidde_NotificationsCounter"></div>`
                : ''
        }
            <img
                alt="Guidde"
                draggable="false"
                src="${getResourceURL(`icons/${btnProps.icon}`)}"
                height="100%"
                style="pointer-events: none"
            />`

        if (btnProps.id) {
            ctaBtn.id = btnProps.id
        }

        if (btnProps.onClick) {
            ctaBtn.addEventListener('click', btnProps.onClick)
        }

        buttonsContainer.appendChild(ctaBtn)
    }

    buttons.forEach(btn => createCTAButton(btn))

    return buttonsContainer
}
